import {
    CONTACT_REQUEST,
    CONTACT_SUCCESS,
    CONTACT_FAILURE,
    ENQUIRY_REQUEST,
    ENQUIRY_SUCCESS,
    ENQUIRY_FAILURE,

} from "../constants/ActionTypes";

const initialState = {
    loading: false,
    saveContact: [],
    saveEnquiry : [],
    error: '',
};

export default function contactReducer(state = initialState, action) {
    // 
    switch (action.type) {
        case CONTACT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTACT_SUCCESS: 
            return {
                ...state,
                // always replacing data
                
                saveContact: action.data,
                loading: false,
                // if adding data
                // data: [...state.data, action.data]
            };
        case CONTACT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

            case ENQUIRY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ENQUIRY_SUCCESS: 
            return {
                ...state,
                // always replacing data
                
                saveEnquiry: action.data,
                loading: false,
                // if adding data
                // data: [...state.data, action.data]
            };
        case ENQUIRY_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error.message,
            };
       
        default:
            return state;
    }
}
